//
//
//
//
//
//

export default {
    props: {
        text: {
            default: "这里还什么都没有"
        },
        imgPic: {
            type: String,
            default: "order"
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/NoData/NoData.vue